import React from 'react';

const ConfirmModal = ({
    visible,
    titulo = 'Confirmação',
    mensagem = 'Deseja continuar?',
    cor = '#28a745',
    onConfirm,
    onCancel,
    textoConfirmar = 'Confirmar',
    textoCancelar = 'Cancelar'
}) => {

    if (!visible) return null;

    return (
        <>
            {/* BACKDROP */}
            <div
                className="modal-backdrop fade show"
                onClick={onCancel}
            />

            {/* MODAL */}
            <div
                className="modal fade show"
                style={{ display: 'block' }}
                onClick={onCancel}
            >
                <div
                    className="modal-dialog"
                    style={{
                        maxWidth: 400,
                        marginTop: '10%'
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="modal-content">

                        {/* HEADER */}
                        <div
                            className="modal-header"
                            style={{
                                backgroundColor: cor,
                                color: '#fff',
                                padding: '10px 15px'
                            }}
                        >
                            <h5 className="modal-title">{titulo}</h5>
                        </div>

                        {/* BODY */}
                        <div
                            className="modal-body"
                            style={{
                                padding: 20,
                                fontSize: 14,
                                textAlign: 'center'
                            }}
                        >
                            {mensagem}
                        </div>

                        {/* FOOTER */}
                        <div
                            className="modal-footer"
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: 10,
                                padding: 10
                            }}
                        >
                            <button
                                className="btn btn-secondary"
                                onClick={onCancel}
                                style={{ width: 100 }}
                            >
                                {textoCancelar}
                            </button>

                            <button
                                className="btn btn-success"
                                onClick={onConfirm}
                                style={{ width: 100 }}
                            >
                                {textoConfirmar}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default ConfirmModal;